module.exports = __webpack_public_path__ + "img/discoverBank.5edca513.png";